/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const BagFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Bag filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#5E1FF0"
        d="M21.45 19.93A1.665 1.665 0 0 1 19.838 22H4.162a1.665 1.665 0 0 1-1.612-2.07l1.096-4.398q.05-.199.05-.404V7.833c0-.92.743-1.666 1.66-1.666h13.117c.903 0 1.64.723 1.66 1.628l.167 7.352q.005.187.05.367z"
      />
      <path
        fill="#5E1FF0"
        fillRule="evenodd"
        d="M12 3.667a2.495 2.495 0 0 0-2.491 2.5H7.848A4.16 4.16 0 0 1 12 2a4.16 4.16 0 0 1 4.152 4.167h-1.66c0-1.382-1.115-2.5-2.492-2.5"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const BagFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'bag-filled-icon'}
      icon={BagFilled}
      {...props}
      size={size}
    />
  );
};
